import { makeSupabaseClient } from '@/shared/infra/supabase'
import { SupabaseSubscribeSignatureRequestStatusRepository } from '@/modules/auth/infra'
import type { SubscribeSignatureRequestStatus } from '@/modules/auth/use-cases'

export function makeSubscribeSignatureRequestStatus(): SubscribeSignatureRequestStatus {
  return new SupabaseSubscribeSignatureRequestStatusRepository(makeSupabaseClient()).execute
}
